import { AfterViewInit, Directive, HostListener } from '@angular/core';
import { Password } from 'primeng/password';
/**
 * add attributes to the the input element
 */
@Directive({
  selector: '[appPasswordInputAttr]',
})
export class PasswordInputAttrDirective implements AfterViewInit {
  /**
   * input html element
   */
  inputEle: HTMLInputElement;

  /**
   * touch event handler
   */
  private onTouch: any = () => {};

  /**
   * constructor to inject dependency
   * @param pPassword instance of password
   */
  constructor(private pPassword: Password) {}

  /**
   * after view init
   */
  ngAfterViewInit() {
    this.inputEle = this.pPassword.el.nativeElement.querySelector('input');
    this.inputEle.setAttribute('maxlength', '15');
  }
}
